module.exports = __webpack_public_path__ + "static/media/HCMM116.ec2e6927.jpg";